import React, { SFC } from "react";
import withContentWrap, { PropsType as WithContentWrapProps } from "../../hoc/withContentWrap";
import withVerticalSpacing, { PropsType as WithVerticalSpacingProps } from "../../hoc/withVerticalSpacing";
import "./style.scss";

type PropsType = HTMLProps<HTMLDivElement> & {
    coordinates?: string;
};

const Map = (props): SFC => {
    return (
        <div id={props.id} className="Map">
            <div className="Map__maps">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10761.686846111339!2d6.159252129833689!3d52.243021328543634!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c7eaf7d64b8939%3A0xb1ceb324d77ba0d7!2sZutphenseweg+6%2C+7418+AJ+Deventer!5e0!3m2!1snl!2snl!4v1541539216078"
                    frameBorder="0"
                    style={{ border: 0 }}
                    allowFullScreen
                />
            </div>
            {/* <div className="Map__text">
                <div className="Map__text-wrap">{props.children}</div>
            </div> */}
        </div>
    );
};

export default withVerticalSpacing(withContentWrap(Map));
